import React from "react";
import { Locale } from "@/i18n/routing";
import { Document } from "@/types/search/suggestions-search-response";
import { ListItemText } from "@mui/material";
import Link from "next/link";
import { injectSourceIntoUrl } from "@/config/unified-search-config";
import styles from "./styles.module.css";

interface SearchSuggestionResultItemProps {
  document: Document,
  sectionBorderColor: string,
  sectionTitle: string,
  searchTerm: string,
  locale: Locale,
  onResultClick?: () => void // Add this prop

}

const formatPrice = (price: number, locale: string = "en-US"): string =>
  new Intl.NumberFormat(locale).format(price);

const SearchSuggestionResultItem: React.FC<SearchSuggestionResultItemProps> = ({
                                                                                 document,
                                                                                 sectionBorderColor,
                                                                                 sectionTitle,
                                                                                 searchTerm,
                                                                                 locale,
                                                                                 onResultClick
                                                                               }) => {

  const space = " ";
  const escapeRegExp = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const term = searchTerm.trim().split(space).map(escapeRegExp).join("|");
  const pattern = term ? new RegExp(term, "gi") : null;
  const termMatch = pattern
    ? document.name.replace(pattern, (match: string) => `<span style='font-weight:bold;'>${match}</span>`)
    : document.name;

  const docUrl = document.url.replace("/en/", "/en-us/");
  const docSource = injectSourceIntoUrl(docUrl, "header_searchbox");

  const handleLinkClick = () => {
    if (onResultClick) {
      onResultClick();
    }
  };

  if (sectionTitle !== "TourDetailPage") {
    return (
      <ListItemText key={document.id} sx={{ marginLeft: 2, borderLeft: "3px solid", borderLeftColor: sectionBorderColor }}
                    primary={
                      <Link href={docSource} passHref className={styles.link} onClick={handleLinkClick}>
                        <div className={styles.contentWrapper}>
                          <p style={{ marginLeft: "10px" }} className={styles.genericTitle} dangerouslySetInnerHTML={{ __html: termMatch }} />
                        </div>
                      </Link>
                    } />
    );

  }
  const offerText = document.offers ? "Save up to: $" : "";
  const offerRate = document.offers ? document.offers[0].rate : "";
  const offerSavings = `${offerText}${offerRate}`;
  const tourPrice = document.price ? `$${formatPrice(document.price, locale)} pp` : "";

  return (

    <ListItemText key={document.id} sx={{ marginLeft: 2, borderLeft: "3px solid", borderLeftColor: sectionBorderColor }}
                  primary={

                    <div>
                      <Link href={document.url} passHref className={styles.link} onClick={handleLinkClick}>

                        <div className={styles.contentWrapper} style={{ marginLeft: "10px" }}>
                          <p className={styles.genericTitle} dangerouslySetInnerHTML={{ __html: termMatch }} />
                          <p className={styles.price}>
                            {tourPrice}
                          </p>
                          <p className={styles.save}>
                            {(document.offers) && offerSavings}
                          </p>

                        </div>


                      </Link>
                    </div>

                  } />

  );



};

export default SearchSuggestionResultItem;
